import { FC, useState, Fragment, useMemo, useRef, useEffect } from "react";
import { useRequest, useSafeState, useLockFn } from "ahooks";
import { useLocation, useNavigate } from "react-router-dom";
import { useSpring, animated } from "@react-spring/web";
import { Loader, Panel, Alert, HelpHead } from "../components";
import { getArticles, getArticleDetail } from "../api";
import Centre from "../../public/Centre.svg";

import dayjs from "dayjs";
import numeral from "numeral";
// @ts-ignore
import { LuckyWheel } from "@lucky-canvas/react";

const RightIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.172 12.0003L8.22205 16.9503L9.63605 18.3643L16 12.0003L9.63605 5.63626L8.22205 7.05026L13.172 12.0003Z"
      fill="white"
      fillOpacity="0.4"
    />
  </svg>
);

const LeftIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.828 10.9997H20V12.9997H7.828L13.192 18.3637L11.778 19.7777L4 11.9997L11.778 4.22168L13.192 5.63568L7.828 10.9997Z"
      fill="white"
    />
  </svg>
);

export const Help = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { data, error, loading } = useRequest<any, any>(getArticles, {
    cacheKey: `cacheKey-helplist`,
    staleTime: -1,
    cacheTime: -1,
  });

  const checkLoginStatus = () => {
    let userInfo;
    console.log(userInfo);
    //@ts-ignore
    const loginStatus = JsBridge?.isLogin?.();
    if (!loginStatus) {
      try {
        //@ts-ignore
        JsBridge?.openNativePage?.(JSON.stringify({ pageName: "login" }));
      } catch (error) {
        //@ts-ignore
        dsBridge?.call?.(
          "openNativePage",
          JSON.stringify({ pageName: "integral-feedback" })
        );
      }
    } else {
      // @ts-ignore
      userInfo = JsBridge?.getUserInfo?.();
      var canCustomerServer = null;
      var option = {
        openUrl: "https://111.173.119.203:45443",
        token: "67aa98823a51c1f53818982058417121",
        kefuid: "",
        isShowTip: false, // Disable auto display of chat button
        mobileIcon: "",
        pcIcon: "",
        windowStyle: "center",
        domId: "customerServerTip",
        insertDomNode: "body", // Append chat window to body
        sendUserData: {
          uid: userInfo.uId,
          nickName: userInfo.nickName,
          phone: "",
          sex: "",
          avatar: userInfo.avatar,
          openid: "",
        },
      };
      // @ts-ignore
      if (!canCustomerServer) {
        // @ts-ignore
        canCustomerServer = new initCustomerServer(option);
        // @ts-ignore
        canCustomerServer.init();
        // @ts-ignore
        canCustomerServer.getCustomeServer(); // Show chat window
      } else {
        // @ts-ignore
        canCustomerServer.getCustomeServer();
        console.log("Chat server already initialized.");
      }
      // @ts-ignore
      //  const name = `DYLS-${userInfo.nic}`
      //  const hrefLink = `https://111.173.119.203:45443/chat/mobile?noCanClose=1&token=67aa98823a51c1f53818982058417121&uid=${userInfo.uId}&nickName=${userInfo.nickName}&avatar=${userInfo.avatar}`
      // window.location.href = hrefLink
    }
  };

  const handleFeedback = () => {
    const nativePageData = JSON.stringify({ pageName: "integral-feedback" });

    console.log("Opening native page with data:", nativePageData); // This will log the value

    try {
      //@ts-ignore
      JsBridge?.openNativePage?.(
        JSON.stringify({ pageName: "integral-feedback" })
      );
    } catch (error) {
      //@ts-ignore
      dsBridge.call(
        "openNativePage",
        JSON.stringify({ pageName: "integral-feedback" })
      );
    }
  };

  const list = useMemo(() => {
    return data?.data ?? [];
  }, [data?.data]);

  const routerLink = () => {
    if (location.pathname === "/help") {
      try {
        // @ts-ignore
        JsBridge?.openNativePage?.(JSON.stringify({ pageName: "invite-home" }));
      } catch (e) {
        // @ts-ignore
        dsBridge.call(
          "openNativePage",
          JSON.stringify({ pageName: "invite-home" })
        );
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="h-full min-h-screen bg-darkbg">
      <button
        onClick={routerLink}
        className="w-[50px] top-[15px] left-[20px] z-[999] absolute focus:outline-none bg-darkbg focus:bg-darkbg"
      >
        {LeftIcon}
      </button>
      <HelpHead title="帮助中心" nomore />

      {list.map((i: any) => (
        <div className="flex flex-col" key={i.id}>
          <div className="w-full px-4 py-3">
            <p className="text-white text-opacity-60 text-sm font-normal">
              {i?.name ?? ""}
            </p>
          </div>
          {(i?.articles ?? []).map((sub: any) => (
            <button
              onClick={() => {
                navigate(`/helpdetail/${sub.id}`);
              }}
              className="py-4 mx-4  text-white text-base text-opacity-90 border-b border-b-white/5 flex justify-between"
            >
              <div className="flex gap-2 items-center ">
                <span className="w-1 h-3 bg-orange-secondary-gradient rounded"></span>
                {sub.title}
              </div>
              {RightIcon}
            </button>
          ))}
        </div>
      ))}

      <div className="jf-foot bg-neutral-800 bg-opacity-90 py-2 px-4 pb-[30px]">
        <button
          className="bg-orange-secondary-gradient text-sm px-6 py-3 text-white font-medium rounded w-full "
          onClick={handleFeedback}
        >
          我要反馈
        </button>
      </div>
    </div>
  );
};
